<template>
  <main>
    <div class="py-4 pt-5 container-fluid">
      <GridRow>
        <GridCol :size="12">
          <MetaSection>
            <div class="text-right">
              <argon-button :to="{ name: 'Menu' }" outline isRouteLink>Kembali</argon-button>
            </div>
          </MetaSection>
        </GridCol>
        <GridCol :size="12">
          <form action="" @submit.prevent="submit()">
            <cards footerstyle="background-color: #ebeffb;" :useFooter="true">
              <template v-slot:footer>
                <div class="text-right">
                  <div class="d-flex flex-row-reverse gap-2">
                    <argon-button>Simpan</argon-button>
                    <argon-button :to="{ name: 'Menu' }" outline isRouteLink>Batalkan</argon-button>
                  </div>
                </div>
              </template>
              <template v-slot:header-action>
                <div>
                  <router-link :to="{ name: 'Master Data Kpi' }" class="btn btn-outline-primary">Kembali</router-link>
                </div>
              </template>
              <FieldsetComponent title="Informasi Menu"
                description="Isi kolom disamping dengan baik dan benar agar nama menu bisa terdaftar dalam aplikasi">
                <div class="flex flex-col gap-5">
                  <form-group label="Nama Menu" idinput="name">
                    <input type="text" @keyup="setSlug()" name="name" id="name" class="form-control"
                      placeholder="Silakan tulis nama menu disini" v-model="data.title">
                  </form-group>

                  <form-group label="Icon" idinput="icon">
                    <div class="row">
                      <GridCol v-for="(items, index) in getIcon()" :key="index" md="4">
                        <div class="d-flex flex-column">
                          <div v-for="(item, indx) in items" :key="indx">
                            <input style="width: 2rem;height: 2rem;" type="radio" value="1" v-model="data.status" name="status"
                                :id="item.split(' ').join('').split('-').join('')" :aria-label="'Icon ' + item" autocomplete="off">
                            <label class="m-0" :for="item.split(' ').join('').split('-').join('')"><font-awesome-icon :icon="item" aria-hidden="true" /></label>
                          </div>
                        </div>
                      </GridCol>
                      <GridCol md="4"></GridCol>
                      <GridCol md="4"></GridCol>
                    </div>
                  </form-group>

                  <form-group label="Deskripsi" idinput="description">
                    <input type="text" name="description" id="description" placeholder="Silakan tulis deskripsi"
                      class="form-control" v-model="data.description">
                  </form-group>

                  <form-group label="Label" idinput="label">
                    <div class="form-control">
                      &nbsp;{{ data.slug ?? "" }}
                    </div>
                  </form-group>
                </div>
              </FieldsetComponent>

              <FieldsetComponent title="Sub Menu"
                description="Silakan buat sub menu sesuai dengan menu yang ada">
                <div class="d-flex flex-column gap-5">
                  <form-group label="Tulis Nama Sub" hint="Tambah sub menu sesuai dengan menu">
                    <!-- Button trigger modal -->
                    <ArgonButton type="button" databstoggle="modal" databstarget="#exampleModal" outline>
                      <font-awesome-icon icon="fa-solid fa-plus" /> Tambah Sub Menu
                    </ArgonButton>
                    <div class="table-responsive">
                      <table class="table">
                        <thead>
                          <tr>
                            <th scope="col">Sub Menu</th>
                            <th scope="col">Aksi</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in data.submenu" :key="index">
                            <td>{{ item.title ?? "" }}</td>
                            <td>

                              <div class="d-flex flex-row gap-2 justify-content-end">
                                <div @click.prevent="deleteSub(item.id)">
                                  <ArgonButton type="button" outline>Hapus</ArgonButton>
                                </div>
                                <ArgonButton @click="this.sub=JSON.parse(JSON.stringify(item))" type="button" databstoggle="modal" databstarget="#exampleModal">Ubah</ArgonButton>
                              </div>
                            </td>
                          </tr>
                          <tr v-for="(item, index) in subs" :key="index">
                            <td>{{ item.title ?? "" }}</td>
                            <td>
                              <div class="d-flex flex-row gap-2 justify-content-end">
                                <div @click.prevent="removeSub(index)">
                                  <ArgonButton type="button" outline>Hapus</ArgonButton>
                                </div>
                                <ArgonButton @click="selectEditSub(index)" type="button" databstoggle="modal" databstarget="#exampleModal">Ubah</ArgonButton>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </form-group>
                </div>
              </FieldsetComponent>
            </cards>
          </form>
        </GridCol>
      </GridRow>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <form @submit.prevent="saveModal()">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Sub Menu</h5>
              <button type="button" class="btn-close" style="color: #000;" data-bs-dismiss="modal" aria-label="Close"><font-awesome-icon icon="fa-solid fa-xmark" /></button>
            </div>
            <div class="modal-body">
              <div class="d-flex flex-column gap-2">
                <FormGroup label="Nama Sub Menu">
                  <input type="text" @keyup="setSubSlug()" name="sub-title" id="sub-title" class="form-control" v-model="sub.title">
                </FormGroup>
                <FormGroup label="Label">
                  <div class="form-control">
                    &nbsp;{{ sub.slug }}
                  </div>
                </FormGroup>
                <FormGroup label="Deskripsi">
                  <input type="text" name="sub-description" id="sub-description" class="form-control"
                    v-model="sub.description">
                </FormGroup>
              </div>
            </div>
            <div class="modal-footer">
              <ArgonButton type="button" databsdismiss="modal" outline>Batalkan</ArgonButton>
              <ArgonButton type="submit" databsdismiss="modal">Simpan</ArgonButton>
            </div>
          </form>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Cards from "@/components/CardComponent.vue";
import FormGroup from "@/components/FormGroup.vue";
import MenuApi from "@/repository/api/MenuApi";
import FieldsetComponent from "@/views/components/FieldsetComponent.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import MetaSection from "@/components/MetaSection.vue";
// import CollapsibleInput from "@/components/CollapsibleInput.vue";
import GridRow from "@/components/grid/GridRow.vue";
import GridCol from "@/components/grid/GridCol.vue";
// import InputForm from '@/components/InputForm.vue';


export default {
  name: "profile",
  data() {
    return {
      showMenu: false,
      data: {
        submenu: [],
      },
      sub: {
        title: "",
        slug: "",
        description: "",
      },
      subs: []
    };
  },
  components: {
    FieldsetComponent,
    Cards,
    FormGroup,
    ArgonButton,
    MetaSection,
    GridRow,
    GridCol,
    // InputForm,
  },

  async mounted() {
    if (this.$route.params.id) {
      await this.getData();
    }
  },
  methods: {
    getIcon() {
      let data = ['fa-solid fa-xmark', 'fa-solid fa-check', 'fa-solid fa-eye', 'fa-solid fa-eye-slash', 'fa-solid fa-ellipsis', 'fa-solid fa-desktop', 'fa-solid fa-chevron-left', 'fa-solid fa-chevron-right', 'fa-solid fa-plus', 'fa-solid fa-angle-down', 'fa-solid fa-users', 'fa-solid fa-signal', 'fa-solid fa-clipboard-list', 'fa-solid fa-file-lines', 'fa-solid fa-clipboard-check', 'fa-solid fa-user', 'fa-solid fa-bars'];
      let length = JSON.parse(JSON.stringify(data.length));
      let tmp = [];
      let group = 3
      for (let index = 0; index < group; index++) {
        tmp.push(data.splice(0, length/3))
      }
      return tmp;
    },
    async changeId(id) {
      await this.$router.push({ name: 'Menu Edit', params: { id: id } })
      await this.getData();
    },
    selectEditSub(index) {
      this.sub = JSON.parse(JSON.stringify(this.subs?.[index] ?? []));
      console.log(this.subs)
    },
    setSubSlug() {
      this.sub.slug = String(this.sub.title).toLowerCase().split(' ').join('-')
    },
    setSlug() {
      this.data.slug = String(this.data.title).toLowerCase().split(' ').join('-')
    },
    async deleteSub(id) {
      this.$swal({
        icon: "warning",
        title: "Apakah anda yakin ingin menghapus?",
        text: "semua perubahan di form ini yang belum tersimpan akan hilang",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$store.state.loading = true;
          await MenuApi.delete(id).then(() => {
            this.getData();
            this.$swal({
              icon: "success",
              title: "Berhasil"
            });
          }).catch((error) => {
            this.$swal({
              icon: "error",
              title: "Error",
              text: error.response.data.message,
            });
          });
          this.$store.state.loading = false;
        }
      })
    },
    async removeSub(index) {
      this.subs.splice(index, 1);
    },
    async saveModal() {
      this.$store.state.loading = true;
      if (this.sub.id) {
        // Object.keys(this.sub).forEach((item) => {
        //   switch (item) {
        //     case "submenu":
        //       break;
        //     default:
        //       this.sub.append(item, this.sub[item]);
        //       break;
        //   }
        // })

        await MenuApi.update(this.sub.id, this.sub).then(() => {
          this.$swal({
            icon: "success",
            title: "Berhasil",
          });

          this.data.submenu[this.data.submenu.findIndex((item) => {
            return item.id == this.sub.id
          })] = JSON.parse(JSON.stringify(this.sub))
        }).catch((error) => {
          this.$swal({
            icon: "error",
            title: error.response.data.message,
          });
        });
      }
      else {
        this.subs.push(JSON.parse(JSON.stringify(this.sub)))
      }
      this.sub = {
        title: "",
        slug: "",
        description: "",
      }
      this.$store.state.loading = false;
    },
    async submit() {
      this.$store.state.loading = true;
      this.data.permissions = this.selectedPermission;
      let data = new FormData();
      Object.keys(this.data).forEach(item => {
        switch (item) {
          case "submenu":
            break;
          default:
            data.append(item, this.data[item]);
            break;
        }
      });

      if (this.subs.length > 0) {
        data.append('sub', JSON.stringify(this.subs));
      }

      if (this.$route.params.id) {
        await MenuApi.update(this.$route.params.id, data).then(() => {
          this.$swal({
            icon: "success",
            title: "Berhasil",
          }).then(() => {
            this.$router.push({ name: "Menu" });
          });
        }).catch((error) => {
          this.$swal({
            icon: "error",
            title: error.response.data.message,
          });
        });
      }
      else {
        await MenuApi.post(data).then(() => {
          this.$swal({
            icon: "success",
            title: "Berhasil",
          }).then(() => {
            this.$router.push({ name: "Menu" });
          });
        }).catch((error) => {
          this.$swal({
            icon: "error",
            title: error?.response?.data?.message ?? "",
          });
        });
      }
      this.$store.state.loading = false;
    },
    async getData() {
      this.$store.state.loading = true;
      await MenuApi.get(this.$route.params.id).then((response) => {
        this.data = response.data;
      }).catch((error) => {
        this.$swal({
          icon: "error",
          title: error?.response?.data?.message,
        }).then(() => {
          this.$router.push({ name: "Menu" });
        });
      })
      this.$store.state.loading = false;
    }
  },
};
</script>
